import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DialogComponent } from '@src/app/shared/components/dialog/dialog.component';
import { SharedModule } from '@src/app/shared/shared.module';

export interface SaveReversalConfirmationData {
  settlementDate: string;
  settlementNotional: string;
  settlementSpot: string;
  settlementRate: string;
  netAmount: number;
}

@Component({
  selector: 'app-modal-save-reversal-confirmation',
  templateUrl: './modal-save-reversal-confirmation.component.html',
  styleUrls: ['./modal-save-reversal-confirmation.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule],
})
export class ModalSaveReversalConfirmationComponent {
  @ViewChild('dialog') dialogRef!: DialogComponent;

  @Output() confirmSave = new EventEmitter<void>();

  data: SaveReversalConfirmationData | null = null;

  open(data: SaveReversalConfirmationData): void {
    this.data = data;
    this.dialogRef?.open(
      '',
      '',
      'Salvar Reversão',
      'Cancelar',
      '',
      'save-reversal-confirmation',
      false,
      false
    );
  }

  close(): void {
    this.dialogRef?.close();
  }

  handleConfirm(): void {
    this.confirmSave.emit();
    this.close();
  }
}
